"use client";
import { cn as e } from "../../../utils/utils.mjs";
import { Text as t } from "../../atoms/Text/Text.mjs";
import { SelectItem as n, SelectItemText as r } from "../../atoms/Select/Select.mjs";
import { Fragment as i, jsx as a, jsxs as o } from "react/jsx-runtime";
//#region src/components/molecules/MediaSelect/MediaSelectItem.tsx
var s = ({ className: s, icon: c, selectItemLabel: l, children: u, ...d }) => /* @__PURE__ */ a(n, {
	className: e("flex items-center gap-2 px-4 py-2 dark:text-neutral-dark-1000 dark:hover:bg-neutral-dark-400 dark:data-[state=checked]:bg-neutral-dark-400 dark:focus:bg-neutral-dark-400", s),
	...d,
	children: l ? /* @__PURE__ */ o(i, { children: [
		/* @__PURE__ */ a("span", {
			className: "hidden",
			children: /* @__PURE__ */ a(r, {
				fontWeight: "regular",
				children: /* @__PURE__ */ a("span", { children: u })
			})
		}),
		c && /* @__PURE__ */ a("span", {
			className: "shrink-0 size-4 [&_path]:fill-white",
			children: c
		}),
		/* @__PURE__ */ a(t, {
			fontWeight: "regular",
			asChild: !0,
			children: /* @__PURE__ */ a("span", { children: l })
		})
	] }) : /* @__PURE__ */ o(i, { children: [c && /* @__PURE__ */ a("span", {
		className: "shrink-0 size-4 [&_path]:fill-white",
		children: c
	}), /* @__PURE__ */ a(r, {
		fontWeight: "regular",
		children: /* @__PURE__ */ a("span", { children: u })
	})] })
});
//#endregion
export { s as MediaSelectItem };
